package com.ijoin.util.datetime

import kotlin.time.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import kotlinx.datetime.toLocalDateTime

actual fun currentLocalDate(): LocalDate =
    Clock.System.todayIn(TimeZone.currentSystemDefault())

actual fun currentLocalDateTime(): LocalDateTime =
    Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())

actual fun currentDateInTimeZone(timeZoneId: String?): LocalDate {
    val zone = timeZoneId?.let { runCatching { TimeZone.of(it) }.getOrNull() } ?: TimeZone.currentSystemDefault()
    return Clock.System.now().toLocalDateTime(zone).date
}

actual fun currentDateTimeInTimeZone(timeZoneId: String?): LocalDateTime {
    val zone = timeZoneId?.let { runCatching { TimeZone.of(it) }.getOrNull() } ?: TimeZone.currentSystemDefault()
    return Clock.System.now().toLocalDateTime(zone)
}
